import { yupResolver } from "@hookform/resolvers/yup";
import Form from "components/forms/form";
import Checkbox from "components/forms/inputs/checkbox";
import FormButtons from "components/forms/buttons";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { FormSubmitFunction } from "lib/form";
import { SubmitButton } from "components/forms/buttons.utils";

export interface FormModel {
  agree: boolean;
}

interface ListObligationFormProps {
  agree: boolean;
  onSubmit: FormSubmitFunction;
}

const schema = yup
  .object({
    agree: yup.boolean().validateRequired(),
  })
  .required();

const ListObligationForm: FunctionComponent<ListObligationFormProps> = ({
  agree,
  onSubmit,
}) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      agree,
    },
  });

  return (
    <Form onSubmit={onSubmit} methods={methods}>
      <Grid>
        <Row>
          <Col>
            <Checkbox name="agree" label="Hyväksyn ehdot ja velvoitteet" />
          </Col>
        </Row>
        <FormButtons
          buttons={[
            {
              ...SubmitButton,
              text: "Tallenna ja jatka",
              align: "right",
            },
          ]}
        />
      </Grid>
    </Form>
  );
};

export default ListObligationForm;
